import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import ReactModal from 'react-modal';
import { FormattedMessage } from 'react-intl';

import Box from '../box/box.jsx';
import Button from '../button/button.jsx';
import CloseButton from '../close-button/close-button.jsx';

import backIcon from '../../lib/assets/icon--back.svg';
import { ArrowLeft, ChevronLeftCircleIcon, LogIn } from 'lucide-react';
import helpIcon from '../../lib/assets/icon--help.svg';

import styles from './modal.css';

const ModalComponent = props => (
    <ReactModal
        isOpen
        className={classNames(styles.modalContent, props.className, {
            [styles.fullScreen]: props.fullScreen
        })}
        contentLabel={props.contentLabel}
        overlayClassName={styles.modalOverlay}
        onRequestClose={props.onRequestClose}
    >
        <Box
            dir={props.isRtl ? 'rtl' : 'ltr'}
            direction="column"
            grow={1}
            style={{ minWidth: 0, width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}
        >
            <div className={classNames(styles.header, props.headerClassName, 'bg-gradient-to-r from-cyan-600 via-blue-900 to-cyan-600 flex justify-between items-center relative')}>
                {props.onHelp ? (
                    <div
                        className={classNames(
                            styles.headerItem,
                            styles.headerItemHelp,
                            "text-lg font-semibold"
                        )}
                    >
                        <Button
                            className={styles.helpButton}
                            iconSrc={helpIcon}
                            onClick={props.onHelp}
                        >
                            <FormattedMessage
                                defaultMessage="Help"
                                description="Help button in modal"
                                id="gui.modal.help"
                            />
                        </Button>
                    </div>
                ) : null}
                <div
                    className={classNames(
                        styles.headerItem,
                        styles.headerItemTitle,
                        "text-lg font-semibold"
                    )}
                >
                    {props.headerImage ? (
                        <img
                            className={styles.headerImage}
                            src={props.headerImage}
                        />
                    ) : null}
                    {props.contentLabel}
                
                </div>
                {/* <div
                    className={classNames(
                       styles.headerItem,
                       "ml-0"
                    )}
                > */}
                    {/* {props.fullScreen ? (
                        <Button
                            className="absolute right-4 bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-full"
                            onClick={props.onSignIn} // You'll need to add this prop and handler
                        >
                            <span className="flex items-center justify-center">
                                <LogIn className="mr-2 inline-block" size={20} />
                                <span className="text-sm font-semibold">Sign In</span>
                            </span>
                        </Button>
                    ) : null} */}
                {/* </div> */}
                <div
                    className={classNames(
                        styles.headerItem,
                        styles.headerItemClose
                    )}
                >
                    {props.fullScreen ? (
                        <Button
                            className={classNames(styles.backButton)}
                            onClick={props.onRequestClose}
                        >
                            <span className="flex items-center justify-center">
                                <ChevronLeftCircleIcon className="mr-2 leading-none inline-block" size={24} />
                                <span className='text-lg font-semibold'>
                                    Back
                                </span>
                            </span>
                        </Button>
                    ) : (
                        <CloseButton
                            size={CloseButton.SIZE_LARGE}
                            onClick={props.onRequestClose}
                        />

                    )}
                </div>
            </div>
            {props.children}
        </Box>
    </ReactModal>
);

ModalComponent.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    contentLabel: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]).isRequired,
    fullScreen: PropTypes.bool,
    headerClassName: PropTypes.string,
    headerImage: PropTypes.string,
    isRtl: PropTypes.bool,
    onHelp: PropTypes.func,
    onRequestClose: PropTypes.func
};

export default ModalComponent;
